import Loader from "react-loader-spinner";
import { Link } from "react-router-dom";

function PhoneNumber({ handleChange, handleRequestOtp, isRequestingOTP }) {
  return (
    <>
      <p className="mb-6">Enter your phone number to reset your pin.</p>
      <form className="mb-6" onSubmit={handleRequestOtp}>
        <label className="form-label" htmlFor="number">
          Phone Number
        </label>
        <div className="input-group mb-3">
          <div className="input-group-prepend">
            <span className="input-group-text">+234</span>
          </div>
          <input
            type="tel"
            className="form-control"
            onChange={handleChange}
            name="phone_number"
            title="Numbers only, e.g. 08023456789"
            maxLength="11"
            required
            // value={phoneNumber}
            pattern="0[0-9]{10}"
            id="phone_number"
            placeholder="08023456789"
          />
        </div>

        {isRequestingOTP ? (
          <button className="btn w-100 btn-primary">
            <Loader type="Oval" color="#fff" width={20} height={20} />
          </button>
        ) : (
          <button className="btn w-100 btn-primary" type="submit">
            Next
          </button>
        )}
      </form>
      <p className="mb-0">
        Remembered your password?{" "}
        <Link to="/login" className="text-decoration-none fw-bold">
          Login
        </Link>
        .
      </p>
    </>
  );
}

export default PhoneNumber;
